import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrlFinanceComponent} from './components/prl-finance/prl-finance.component';
import {prlAuthentificationGuard} from '../../shared/services/prl-authentification-guard';
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'finance',
        component: PrlFinanceComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {pageName: 'Finance Page'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlFinanceRoutingModule {
}
